import { INutrientItem } from "@/types/Nutrition.types";

export const GRAM_UNIT = "g" as const;

/**
 * Default nutrients for Pet Foods
 * These are the standard guaranteed analysis nutrients that should be displayed
 * when no nutrients are loaded from the API.
 * `id` values with the `default-` prefix are client-only: they are not sent to
 * `saveNutrient` and are replaced in state by the id returned in the response after save.
 */
export const PET_FOOD_DEFAULT_NUTRIENTS: INutrientItem[] = [
    {
        id: "",
        nutrient: "Crude Protein (min)",
        unitOfMeasure: "%",
        valueOnLabCoA: "",
        valueToAppearOnLabel: "",
        nutritionUnitOfMeasure: "%"
    },
    {
        id: "",
        nutrient: "Crude Fat (min)",
        unitOfMeasure: "%",
        valueOnLabCoA: "",
        valueToAppearOnLabel: "",
        nutritionUnitOfMeasure: "%"
    },
    {
        id: "",
        nutrient: "Crude Fiber (max)",
        unitOfMeasure: "%",
        valueOnLabCoA: "",
        valueToAppearOnLabel: "",
        nutritionUnitOfMeasure: "%"
    },
    {
        id: "",
        nutrient: "Moisture (max)",
        unitOfMeasure: "%",
        valueOnLabCoA: "",
        valueToAppearOnLabel: "",
        nutritionUnitOfMeasure: "%"
    }
];
